import React, { useState } from "react";
import { formatDate, truncateText } from "../../common/Helper";
import { useMarkAsRead } from "../../common/hooks/useNotifications";

const NotificationItem = ({ item, isActive = false }) => {
  const markAsReadMutation = useMarkAsRead();
  const [isExpanded, setIsExpanded] = useState(false);

  const handleClick = () => {
    if (!item.isRead) {
      markAsReadMutation.mutate(item._id);
    }
  };

  const isMarkingThisItem = markAsReadMutation.isPending &&
    markAsReadMutation.variables === item._id;

  const toggleExpand = (e) => {
    e.stopPropagation();
    setIsExpanded(!isExpanded);
  };

  const message = item?.message || '';
  const isLongMessage = message.length > 13;
  const displayMessage = isExpanded ? message : truncateText(message, 15);

  return (
    <div
      className={`notification-item ${isActive ? 'active' : ''} d-flex align-items-center gap-2 px-3 py-2 mb-1`}
      onClick={handleClick}
      style={{
        cursor: 'pointer',
        pointerEvents: isMarkingThisItem ? 'none' : 'auto'
      }}
    >
      <div className="flex-grow-1">
        <h3 className="mb-0 font-500 text-14 text-dark d-flex justify-content-between align-items-center">
          <span>{item?.title}</span>
          <span className="text-primary fw-bold text-decoration-underline text-end">
            {item?.senderdetail?.fullName || (item?.adminDetail?.firstName + " " + item?.adminDetail?.lastName)}
          </span>
        </h3>
        <p className="text-13 mb-0">
          {displayMessage}
          {isLongMessage && (
            <span
              onClick={toggleExpand}
              style={{
                color: '#995D26',
                cursor: 'pointer',
                textDecoration: 'underline',
                marginLeft: '4px'
              }}
            >
              {isExpanded ? ' See less' : ' See more'}
            </span>
          )}
        </p>
        <p className="mb-0 noti-date">{formatDate(item?.createdAt)}</p>
      </div>
      {isMarkingThisItem && (
        <div className="ms-2">
          <span className="spinner-border spinner-border-sm text-primary" />
        </div>
      )}
    </div>
  );
};

export default NotificationItem;